/**
 * Promo Trust Bar — o ticker infinito é o padrão.
 * Remove o carrossel legado (1 mensagem) se algum HTML antigo ainda o injetar.
 */
(function () {
  function restoreMarquee(section) {
    if (!section) return;
    section.classList.remove('promo-trust-bar--ready');
    delete section.dataset.promoTrustReady;
    section.querySelectorAll('.promo-trust-bar__carousel').forEach((node) => node.remove());
    const marquee = section.querySelector('.promo-trust-bar__marquee');
    if (marquee) {
      marquee.style.removeProperty('display');
    }
  }

  function boot() {
    document.querySelectorAll('#header-group .promo-trust-bar, .promo-trust-bar.section').forEach(restoreMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', boot);
})();
